import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SideNav from '../SideNav/SideNav';
import AuthenticatedNavbar from '../AuthenticatedNavbar/AuthenticatedNavbar';

function DashboardLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();

    // Map routes to tab IDs
    const routeToTab = {
        '/discord': 'discord',
        '/manage-subscriptions': 'manage-subscriptions',
        '/odds-screen': 'odds-screen',
        '/results-tracker': 'results-tracker',
    };

    // Determine default tab based on Discord link status
    const defaultTab = user?.discordLinked ? 'manage-subscriptions' : 'discord';
    const activeTab = routeToTab[location.pathname] || defaultTab;

    const allMenuItems = [
        { id: 'discord', label: 'Discord', route: '/discord', showWhen: true },
        { id: 'manage-subscriptions', label: 'Manage Subscriptions', route: '/manage-subscriptions', showWhen: true },
        { id: 'odds-screen', label: 'Odds Screen', route: '/odds-screen', showWhen: true },
        { id: 'results-tracker', label: 'Results Tracker', route: '/results-tracker', showWhen: true },
    ];

    // Filter menu items based on showWhen condition
    const menuItems = allMenuItems.filter(item => item.showWhen);

    const handleTabChange = (tabId) => {
        const menuItem = menuItems.find(item => item.id === tabId);
        if (menuItem) {
            navigate(menuItem.route);
        }
    };

    return (
        <div className="min-h-screen bg-[#020817] relative overflow-x-hidden">
            {/* Fixed Background */}
            <div className="fixed inset-0 z-0 bg-[#020817]"></div>

            {/* Content Wrapper */}
            <div className="relative z-10 overflow-x-hidden w-full bg-[#020817]">
                {/* Sidebar */}
                <SideNav 
                    activeTab={activeTab}
                    setActiveTab={handleTabChange}
                />

                {/* Main Content Wrapper */}
                <div className="min-h-screen flex flex-col ml-20">
                    {/* Header - Fixed at top */}
                    <AuthenticatedNavbar 
                        activeTab={activeTab} 
                        menuItems={menuItems} 
                    />

                    {/* Page Content - with top padding to account for fixed navbar */}
                    <main className="flex-1 pt-[72px]">
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
}

export default DashboardLayout;

